import { DashboardFilter } from "../../types/dashboard"

interface ISelectedFiltersProps {
  requestFilters: DashboardFilter
}

const SelectedFilters = ({requestFilters}: ISelectedFiltersProps) => {

  const checkingAvailableFilters = () => {
    if(
      !requestFilters?.regional?.length &&
      !requestFilters?.categoryIds?.length &&
      !requestFilters?.clientIds?.length &&
      !requestFilters?.contracts?.length &&
      !requestFilters?.vehicleIds?.length
    ) return false

    return true
  }

  const regional = requestFilters?.regional?.length;
  const categories = requestFilters?.categoryIds?.length;
  const clients = requestFilters?.clientIds?.length;
  const contracts = requestFilters?.contracts?.length;
  const vehicles = requestFilters?.vehicleIds?.length

  return (
    <div className="display-flex align-items-center gap-10">
      {checkingAvailableFilters() ? (
        <>
          <p className="margin-0 text-size-14 text-bold">Visão detalhada da operação selecionada:</p>
          <div className="display-flex align-items-center gap-20">
            {regional ? (
              <div className="display-flex align-items-center gap-5">
                <span className="rioglyph rioglyph-role-management text-size-14 margin-top-2"></span>
                <p className="margin-0 text-size-14">{regional}</p>
                <p className="margin-0 text-size-14">{regional === 1 ? 'Regional' : 'Regionais'}</p>
              </div>
            ) : null}

            {categories ? (
              <div className="display-flex align-items-center gap-5">
                <span className="rioglyph rioglyph-tag text-size-14 margin-top-2"></span>
                <p className="margin-0 text-size-14">{categories}</p>
                <p className="margin-0 text-size-14">{categories === 1 ? 'Categoria' : 'Categorias'}</p>
              </div>
            ) : null}

            {clients ? (
              <div className="display-flex align-items-center gap-5">
                <span className="rioglyph rioglyph-transfer text-size-14 margin-top-2"></span>
                <p className="margin-0 text-size-14">{clients}</p>
                <p className="margin-0 text-size-14">{clients === 1 ? 'Cliente' : 'Clientes'}</p>
              </div>
            ) : null}

            {contracts ? (
              <div className="display-flex align-items-center gap-5">
                <span className="rioglyph rioglyph-file-signature text-size-14 margin-top-2"></span>
                <p className="margin-0 text-size-14">{contracts}</p>
                <p className="margin-0 text-size-14">{contracts === 1 ? 'Contrato' : 'Contratos'}</p>
              </div>
            ) : null}

            {vehicles ? (
              <div className="display-flex align-items-center gap-5">
                <span className="rioglyph rioglyph-van-baseline text-size-14 margin-top-2"></span>
                <p className="margin-0 text-size-14">{vehicles}</p>
                <p className="margin-0 text-size-14">{vehicles === 1 ? 'Veículo' : 'Veículos'}</p>
              </div>
            ) : null}
          </div>
        </>
      ) : null}
    </div>
  )
}

export default SelectedFilters
